<h2 class="container-header">WAN Port Info</h2>
@if(wanDataLoading && !errorInWanData) {
<div class="centered-content">
  <mat-spinner class="mainSpinner" [diameter]="40"></mat-spinner>
</div>
}@else if (!wanDataLoading && errorInWanData) {
<div class="header-container">
  <p>Unable To Load WAN Data For Device.</p>
</div>
}@else if(!wanDataLoading && !errorInWanData) {
<div class="wan-data-container">
  <b>Addresses:</b>
  <div class="ip-container">
    @for(ip of wanData?.WanIPV4Addresses; track $index) {
    <mat-card class="ip-card">
      <p>{{ip}}</p>
    </mat-card>
    }
  </div>

  <b>Status:</b>
  <div class="wan-data">
    <mat-card class="wan-data-card">
      <p>Uptime: {{convertFromSecondsToDHMS(wanData?.WanUptime ?? 0)}} | Rx Bytes:
        {{roundToThreeDecimalPlaces(wanData?.WanRxBytes??0)}} MB | Tx Bytes:
        {{roundToThreeDecimalPlaces(wanData?.WanTxBytes??0)}} MB</p>
    </mat-card>
    <button mat-raised-button (click)="getDevicesWANData(id)">
      Refresh WAN Data
    </button>
  </div>
</div>
}

<h2 class="container-header">Total WAN Data Usage</h2>
@if(wanUsageLoading && !errorInWanUsage){
<div class="centered-content">
  <mat-spinner class="mainSpinner" [diameter]="40"></mat-spinner>
</div>
}

@if (!wanUsageLoading && errorInWanUsage) {
<div class="header-container">
  <p>Unable To Load WAN Usage For Device.</p>
</div>
}

@if(!wanUsageLoading && !errorInWanUsage) {
<div class="header">
  <div class="date-input">
    <mat-form-field>
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate (dateChange)="updateWANUsageStart($event)" [value]="wanUsageStartDate"
          placeholder="Start date">
        <input matEndDate (dateChange)="updateWANUsageEnd($event)" [value]="wanUsageEndDate" placeholder="End date">
      </mat-date-range-input>
      <mat-hint>YYYY/MM/DD – YYYY/MM/DD</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="fetchWANUsageData(id)">Get Data</button>
  </div>

</div>
<div #chartContainer>
  <apx-chart [series]="wanChartOptions.series" [chart]="wanChartOptions.chart" [title]="wanChartOptions.title"
    [xaxis]="wanChartOptions.xaxis" [dataLabels]="wanChartOptions.dataLabels" [yaxis]="wanChartOptions.yaxis">
  </apx-chart>
</div>
}


<h2 class="container-header">Total Data Usage</h2>
@if(displaySpinner && !errorOnLoading){
<div class="centered-content">
  <mat-spinner class="mainSpinner" [diameter]="40"></mat-spinner>
</div>
}

@if (!displaySpinner && errorOnLoading) {
<div class="header-container">
  <p>Unable To Load Metrics For Device.</p>
</div>
}

@if(!displaySpinner && !errorOnLoading) {
<div class="header">
  <div class="date-input">
    <mat-form-field>
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate (dateChange)="updateStart($event)" [value]="startDate" placeholder="Start date">
        <input matEndDate (dateChange)="updateEnd($event)" [value]="endDate" placeholder="End date">
      </mat-date-range-input>
      <mat-hint>YYYY/MM/DD – YYYY/MM/DD</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="updateGraph()">Get Data</button>
  </div>
  <div class="usage-totals">
    <div class="usage-container">
      <h3 class="header">
        Sim 1 Totals
      </h3>
      <div class="contents">
        <p>Tx: {{sim1TotalTx}} MB</p>
        <p>Rx: {{sim1TotalRx}} MB</p>
      </div>
    </div>

    <div class="usage-container">
      <h3 class="header">
        Sim 2 Totals
      </h3>
      <div class="contents">
        <p>Tx: {{sim2TotalTx}} MB</p>
        <p>Rx: {{sim2TotalRx}} MB</p>
      </div>
    </div>

  </div>
</div>
<div #chartContainer>
  <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [title]="chartOptions.title"
    [xaxis]="chartOptions.xaxis" [dataLabels]="chartOptions.dataLabels" [yaxis]="chartOptions.yaxis">
  </apx-chart>
</div>
}
<h2 class="container-header">Signal Strength</h2>
@if (!displaySignalStrengthSpinner && !errorOnSignalStrengthLoading) {
<div class="date-input">
  <mat-form-field>
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [rangePicker]="signalPicker">
      <input matStartDate (dateChange)="updateSignalStrengthStart($event)" [value]="signalStrengthStartDate"
        placeholder="Start date">
      <input matEndDate (dateChange)="updateSignalStrengthEnd($event)" [value]="signalStrengthEndDate"
        placeholder="End date">
    </mat-date-range-input>
    <mat-hint>YYYY/MM/DD – YYYY/MM/DD</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="signalPicker"></mat-datepicker-toggle>
    <mat-date-range-picker #signalPicker></mat-date-range-picker>
  </mat-form-field>
  <button mat-raised-button color="primary" (click)="updateSignalStrengthGraph()">Get Data</button>
</div>
<div #chartContainer2>
  <apx-chart [series]="signalStrengthChartOptions.series" [chart]="signalStrengthChartOptions.chart"
    [title]="signalStrengthChartOptions.title" [xaxis]="signalStrengthChartOptions.xaxis"
    [dataLabels]="signalStrengthChartOptions.dataLabels" [stroke]="signalStrengthChartOptions.stroke"
    [colors]="signalStrengthChartOptions.colors" [yaxis]="signalStrengthChartOptions.yaxis">
  </apx-chart>
</div>
}

@if(displaySignalStrengthSpinner && !errorOnSignalStrengthLoading){
<div class="centered-content">
  <mat-spinner class="mainSpinner" [diameter]="40"></mat-spinner>
</div>
}

@if (!displaySignalStrengthSpinner && errorOnSignalStrengthLoading) {
<div class="header-container">
  <p>Unable To Load Signal Strength For Device.</p>
</div>
}